import * as modal from "../util/modal.ts";
import * as Html from "../util/Html.ts";
import * as i18n from "../i18n.ts";
import ApiServer from "../ApiServer.ts";
import * as Storage from "../lib/Storage.ts";
import * as FwDatas from "../FwDatas.ts";
import * as Confetti from "../lib/Confetti.ts";
import { protoExtend } from "../lib/ObjectUtil.ts";
import TPL_PREMIUM from "../modal/premium.mustache";
import TPL_PAYWALL from "../modal/paywall.mustache";
import TPL_PROMO from "../modal/premium_promo.mustache";
import { format } from "../lib/DateUtils.ts";
import Icons from "../svg/Icons.ts";
import { CreditListCache } from "../server/objects/ICredit.ts";

export function displayPromoPopupIfNeeded(){
  var premiumPopup = FwDatas.getState()?.premiumPopup;
  if(premiumPopup){
    var
      atLaunchResetDate = premiumPopup.atLaunchResetDate,
      fromStorage = Storage.localGet('atLaunchResetDate');


    if(fromStorage===null || new Date(fromStorage) < atLaunchResetDate){
      Storage.localSet('atLaunchResetDate',atLaunchResetDate.toISOString())
      Html.trigger(null,'takepremium',['directclick'])
    }
  }
}

ApiServer.types.CoverUriPhoneAndTabletBean.prototype.onDecode = function(){
  const isDarkModeActive = window.matchMedia('(prefers-color-scheme: dark)').matches;
  this.url = isDarkModeActive?this.tablet.darkMode:this.tablet.lightMode
}
ApiServer.types.PremiumPopupConfigurableContentBean.prototype.configureText  = function( values /*: Record<string, string>*/){
  return protoExtend(this,{
    title:renderTemplate(this.title,values),
    description:renderTemplate(this.description,values),
    bannerTitle:renderTemplate(this.bannerTitle,values),
    bannerText:renderTemplate(this.bannerText,values),
  })
}

function promopopup(data){
  modal.openDomModal(TPL_PROMO,data);
}

Html.registerDom({
  async takepremium(from){
    let
      family = FwDatas.getFamily(),
      user = FwDatas.getUser(),
      isKid = user.isKid(),

      data :any = {
        directclick:from==='directclick'||from==='promo',
        blocked:user.isKid()
      },
      [activeCredits,twocheckoutUrls] = await Promise.all([CreditListCache.refresh(),ApiServer.credit2checkouturl2()]) ;
    if(activeCredits.length){
      //premium member card
      data.membercard = {
        avatars:family.members.slice(0,5).map((member,idx)=>{return{thumb:member.thumb(),left:24*idx}}),
        extra: Math.max(family.members.length-5,0),
        extraLeft : 24*5,
        date: format(activeCredits[0].creationDate,'MMMM YYYY')
      }
      data.nameOfPremiumProvider = activeCredits[0].author().name;
      Confetti.start(2000)
      modal.openDomModal(TPL_PREMIUM,data);
      return;
    }

    //TODO handle promo
    data.yearly = formatPrice(twocheckoutUrls.yearly.currency,twocheckoutUrls.yearly.priceFloat);
    data.monthly = formatPrice(twocheckoutUrls.monthly.currency,twocheckoutUrls.monthly.priceFloat);
    data.yearlyByMonth = formatPrice(twocheckoutUrls.yearly.currency,twocheckoutUrls.yearly.priceFloat/12);
    data.monthlyByYear = formatPrice(twocheckoutUrls.monthly.currency,twocheckoutUrls.monthly.priceFloat*12);
    data.trialDays = twocheckoutUrls.monthly.trialDays;

    if(twocheckoutUrls.yearlyPromo){
      data.yearlyPromo = Object.assign(
        twocheckoutUrls.yearlyPromo,
        {
          price:formatPrice(twocheckoutUrls.yearlyPromo.currency,twocheckoutUrls.yearlyPromo.priceFloat -0.001),
          promoPercent:Math.round(twocheckoutUrls.yearlyPromo.percent*100)+'%'
        },
      );
		  var price = data.yearlyPromo.price;
      var percent = twocheckoutUrls.yearlyPromo.promoPercent = Math.round(twocheckoutUrls.yearlyPromo.percent*100)+"%"

      var serverContent = FwDatas.getState().premiumPopup.content
      data.content = serverContent.configureText({price,percentReduc:percent})
    }
    if(twocheckoutUrls.monthlyPromo){
      data.monthlyPromo = Object.assign(
        twocheckoutUrls.monthlyPromo,
        {
          price:formatPrice(twocheckoutUrls.monthlyPromo.currency,twocheckoutUrls.monthlyPromo.priceFloat),
          promoPercent:Math.round(twocheckoutUrls.monthlyPromo.percent*100)+'%'
        }
      );
    }
    var waitingpremium = Storage.sessionGet('waitingpremium');
    if(waitingpremium){
      data.waitingpremium = (new Date().getTime() - new Date(waitingpremium).getTime() < 600000)
    }

    var theModal = modal.openDomModal(TPL_PAYWALL,data);
    function refreshButtonData(){
      var
        yearly = theModal.querySelector('.card.premium').classList.contains('selected'),
        button = theModal.querySelector('a.button'),
        subtitle = button.nextElementSibling.lastElementChild,
        priceBean = yearly?twocheckoutUrls.yearly:twocheckoutUrls.monthly;

      button.setAttribute('href',priceBean.buyUrl)
      if(priceBean.trialDays){
        button.innerHTML = i18n.get('premium_paywall.cta.button_trial',priceBean.trialDays)
        subtitle.innerHTML = i18n.get('premium_paywall.cta.subtitle_trial')
      }else{
        button.innerHTML = i18n.get('actions.continue')
        subtitle.innerHTML = i18n.get('premium_paywall.cta.subtitle')
      }
    }
    refreshButtonData()
    theModal.addEventListener('click',(evt)=>{
      const target = evt.target as HTMLElement;
      const card = target?.closest('.card.premium')
      if (card) {
        theModal.querySelectorAll('.card.premium').forEach(element => {
          if(element===card){
            element.classList.add('selected')
            element.querySelector('icon').innerHTML = Icons.ic_checked.toHTML();
          }else{
            element.classList.remove('selected')
            element.querySelector('icon').innerHTML = Icons.ic_checkbox.toHTML();
          }
        });
        refreshButtonData()
      }
      if(isKid && target?.closest('a')){
        evt.preventDefault()
        modalBlockedForKid();
      }
    })
    theModal.querySelectorAll('.card.faq>flexrow').forEach(cardHead=>cardHead.addEventListener('click',(evt)=>{
      cardHead.parentElement.classList.toggle('open')
    }))

    if(twocheckoutUrls.yearlyPromo && !isKid){
      promopopup(data)
    }
    theModal.querySelector('.promolink')?.addEventListener('click',(evt)=>{
      if(isKid){
        modalBlockedForKid();
      }else{
        promopopup(data)
      }
    })

  }
});

function modalBlockedForKid(){
  modal.simple({
    title:"premium.blockedtitle",
    lottie:"images/lottie/anim_teddy_bear.json",
    message:"premium.blockeddescription",
    button:"premium.blockedbutton"
  })
}

function formatPrice(currency :string, price :number){
  const formatteur = new Intl.NumberFormat(i18n.getSelectedLanguage(), {
    style: 'currency',
    currency:currency||'USD'
  });
  return formatteur.format(price)
}

// Fonction qui remplace les {{}} et [[]]
function renderTemplate(str /*: string*/, values /*: Record<string, string>*/) {
  // 1. Remplacer les {{variable}} par leurs valeurs
  let result = str.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => values[key] ?? "");

  // 2. Mettre en gras le contenu entre [[...]]
  result = result.replace(/\[\[\s*(.*?)\s*\]\]/g, "<hl>$1</hl>");

  return result;
}